import GameTour from "components/game-tour/game-tour";
export default GameTour;
